import { useDispatch } from "react-redux"
import { setIsOpenDialog } from "../../store/feautures/DialogSlice";
import { toast } from "react-toastify";
import { useDeleteDocumentMutation } from "../../store/services/DocumentService";

type IProps = {
    idAzienda: number,
    dataInfo: any
}

export default function DeleteDocument({ idAzienda, dataInfo }: IProps) {

    const dispatch = useDispatch();
    const [deleteDocument] = useDeleteDocumentMutation();

    const handleClose = () => {
        dispatch(setIsOpenDialog(true));
    }

    const handleDelete  = async () => {
        const result: any = await deleteDocument({ idAzienda: idAzienda, idDocument: dataInfo.id });
        if ('error' in result) {
            toast.error(`Documento non eliminato! Errore: ${result?.error?.data?.detail}`)
        } else {
            toast.success(`Documento eliminato! `);
            dispatch(setIsOpenDialog(true));
        }
    }

    return (
        <div className="p-10 min-h-[300px] flex flex-col justify-between">
            <p>Sei sicuro di voler eliminale il documento {dataInfo.nome} ?</p>
            <div className="mt-4 grid grid-cols-2 space-x-4">
                <button onClick={handleClose} type="button" className="h-10 border !text-[#064e3b] !border-[#064e3b] text-white px-2 inline rounded-lg text-md">
                    Annulla
                </button>
                <button onClick={handleDelete} type="button" className="h-10 bg-[#064e3b] text-white px-2 inline rounded-lg text-md">
                    Elimina
                </button>
            </div>
        </div>
    )
}